<div class="body">

    <div class="afiliado" *ngIf="rol != 'ROLE_AFILIADO'">

        <div class="container" style="height:100px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-4">
                    <h1> Postulaciones </h1>
                </div>

                <div class="col-lg-5"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    <select class="form-control" [(ngModel)]="config.itemsPerPage">
        
                        <option value = "10">10</option>
                        <option value = "20">20</option>
                        <option value = "30">30</option>
                        <option value = "50">50</option>
                        
                    </select> </div>

            </div>
            <hr/> <br/>

            <div class="row">

                <div class="col-lg-2 col-xl-2">
                    <h3> Producto </h3>
                </div>

                <div class="col-lg-2 col-xl-2">
                    <h3> </h3>
                </div>

                <div class="col-lg-2 col-xl-2">
                    <h3> RUT </h3>
                </div>

                <div class="col-lg-2 col-xl-2"> <input class="form-control" [value]="" /> </div>

                <div class="col-lg-2 col-xl-2">
                    <h3> N. Solicitud </h3>
                </div>

                <div class="col-lg-2 col-xl-2">
                    <h3> <input class="form-control" [value]="" /> </h3>
                </div>

            </div> <br/>

            <div class="row">

                <div class="col-lg-2">
                    <h3> Fecha Inicial </h3>
                </div>

                <div class="col-lg-2"> <input class="form-control" type="date" [value]="" /> </div>

                <div class="col-lg-2">
                    <h3> Fecha Final </h3>
                </div>

                <div class="col-lg-2"> <input class="form-control" type="date" [value]="" /> </div>

                <div class="col-lg-2">
                    <h3> Estado </h3>
                </div>

                <div class="col-lg-2"> </div>

            </div>
            <hr/> <br/>

            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col"> N° </th>

                            <th scope="col"> Rut </th>

                            <th scope="col"> Nombre y Apellido </th>

                            <th scope="col"> Fecha Ingreso </th>

                            <th scope="col"> Producto </th>

                            <th scope="col"> Tipo de Producto </th>

                            <th scope="col"> Estado </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let postulacion of postulaciones | paginate: config; let i = index">

                            <td> {{postulacion.id}} </td>

                            <td> {{postulacion.rut}} </td>

                            <td> {{postulacion.nombreCompleto}} </td>

                            <td> {{postulacion.fechaCreacion}} </td>

                            <td> {{postulacion.nombreProducto}} </td>

                            <td> {{postulacion.nombreTipoProducto}} </td>

                            <td> {{postulacion.estado}} </td>

                        </tr>

                    </tbody>

                </table> <br/>

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>

            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>

</div>